// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import { YStack, XStack, Text } from 'tamagui';
import { Container } from './Container';
import { useIsMobile } from '../hooks/useIsMobile';

export function Footer() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const LinkText = ({ onPress, children }) => (
    <Text
      fontSize="$3" color="$color8" cursor="pointer"
      hoverStyle={{ color: '$color12' }}
      onPress={onPress}
      style={{ transition: 'color 0.15s' }}
    >
      {children}
    </Text>
  );

  return (
    <YStack borderTopWidth={1} borderTopColor="$color4" paddingVertical="$8">
      <Container>
        <XStack
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent="space-between"
          alignItems="flex-start"
          gap={isMobile ? '$6' : '$8'}
        >
          {/* Logo + tagline */}
          <YStack gap="$2" flex={isMobile ? undefined : 1}>
            <Text
              fontSize="$5"
              fontWeight="700"
              fontFamily="Cinzel"
              letterSpacing={1.5}
              cursor="pointer"
              onPress={() => navigate('/')}
              style={{
                color: "#a03030",
                fontFamily: "Cinzel",              }}
            >
              ROMANS
            </Text>
            <Text fontSize="$2" color="$color6" maxWidth={200}>
              Infrastructure that endures.
            </Text>
          </YStack>

          {/* Products column */}
          <YStack gap="$3">
            <Text fontSize={11} color="$color6" letterSpacing={2} fontWeight="600">
              PRODUCTS
            </Text>
            <LinkText onPress={() => navigate('/products/torch')}>Torch</LinkText>
            <LinkText onPress={() => navigate('/products/statio')}>Statio</LinkText>
            <LinkText onPress={() => navigate('/products/denarius')}>Denarius</LinkText>
            <LinkText onPress={() => navigate('/products/janusledger')}>JanusLedger</LinkText>
          </YStack>

          {/* Open Source column */}
          <YStack gap="$3">
            <Text fontSize={11} color="$color6" letterSpacing={2} fontWeight="600">
              OPEN SOURCE
            </Text>
            <LinkText onPress={() => navigate('/products/pilum')}>Pilum</LinkText>
            <LinkText onPress={() => navigate('/products/scuta')}>Scuta</LinkText>
            <LinkText onPress={() => navigate('/products/vigil')}>Vigil</LinkText>
          </YStack>

          {/* Company column */}
          <YStack gap="$3">
            <Text fontSize={11} color="$color6" letterSpacing={2} fontWeight="600">
              COMPANY
            </Text>
            <LinkText onPress={() => navigate('/about')}>About</LinkText>
            <LinkText onPress={() => window.open('https://logicalbytes.dev', '_blank')}>Blog</LinkText>
            <LinkText onPress={() => navigate('/changelog')}>Changelog</LinkText>
            <LinkText onPress={() => navigate('/contact')}>Contact</LinkText>
            <LinkText onPress={() => window.open('https://github.com/sid-technologies', '_blank')}>GitHub</LinkText>
          </YStack>
        </XStack>

        <YStack marginTop="$6" paddingTop="$4" borderTopWidth={1} borderTopColor="$color3">
          <XStack
            flexDirection={isMobile ? 'column' : 'row'}
            justifyContent="space-between"
            alignItems={isMobile ? 'flex-start' : 'center'}
            gap="$2"
          >
            <Text color="$color6" fontSize="$1" letterSpacing={0.5}>
              &copy; 2026 SID Technologies
            </Text>
            <XStack flexDirection="row" gap="$4">
              <Text
                fontSize="$1" color="$color6" cursor="pointer"
                hoverStyle={{ color: '$color9' }}
                onPress={() => navigate('/privacy')}
                style={{ transition: 'color 0.15s' }}
              >
                Privacy
              </Text>
              <Text
                fontSize="$1" color="$color6" cursor="pointer"
                hoverStyle={{ color: '$color9' }}
                onPress={() => navigate('/terms')}
                style={{ transition: 'color 0.15s' }}
              >
                Terms
              </Text>
            </XStack>
          </XStack>
        </YStack>
      </Container>
    </YStack>
  );
}
